import { styled } from "styled-components";

export const RemoveImageButton = styled.div`
  position: absolute;
  top: 30px;
  left: 0;
  color: #fff;
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  z-index: 1;
  padding: 5px;
  background-color: rgba(79, 79, 79, 0.8);
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
`;
